const paths = require('./pathsDefinitions').obj

export default paths
// export default {
//   repertoireMovies: {
//     path: "repertuar",
//   },
// }
